import React, { Fragment, useEffect, useState, useContext } from "react";
import { ContainerNew, SubMenu, openLayerFn } from "../Layout";
import styled from "styled-components";
import TermsViewer from "../Company/TermsDetail/TermsViewer";
import { _O } from "../../modules/utils";
import { AlertLayer } from './../../components/UI/Dialog';
import { AppContext } from "../../components/AppProvider";
import { getCookie, setCookie } from "../../modules/utils/cookie";
import useTitle from "../../modules/hooks/useTitle";
// props.match.params.signUpChannel 일반가입이 아닌경우 자동으로 계정을 생성하여 보여주어야 함(가입완료는 아님)
export default props => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  useTitle("회원가입_약관동의");
  const [checkYn, setCheckYn] = useState("N");

  const goCerti = () => {
    let goToUrl;
    setCookie("checkTerms", true);
    $("#userToken").val(userinfo.userToken);

    if (userinfo.userToken) {
      goToUrl = "certificateToUpdate/";
    } else {
      // IOS에서 WS연동이 안되는 중(https일때)
      if (phonecfg.phoneOS === "ANDROID") {
        goToUrl = "certificate2/";
      } else {
        goToUrl = "certificate2/";
      }
    }

    $.get(cfg.webUrl + goToUrl, function (data) {
      $("#enc_data").val(data.encData);

      document.form_certificate.action =
        "https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb";
      document.form_certificate.target = "_self";
      document.form_certificate.submit();
    });
  };

  const bottom = (
    <div
      className="under-fix-btnarea"
      style={{ textAlign: "center", margin: "0px 15px", width: "auto" }}>
      <form name="form_certificate" method="post">
        <input type="hidden" name="m" value="checkplusSerivce" />
        <input type="hidden" name="EncodeData" id="enc_data" />
        <input type="hidden" name="param_r1" id="userToken" />
        <input type="hidden" name="param_r2" value={phonecfg.phoneOS} />
        <input
          type="hidden"
          name="param_r3"
          id="signUpChannel"
          value={props.match.params.signUpChannel}
        />
      </form>

      <BtnNext
        innerWidth={window.innerWidth}
        onClick={() => {
          checkYn === "Y"
            ? _O.Open(
                props.match.params.signUpChannel === "500"
                  ? "/membership/inputUserInfo/500"
                  : goCerti()
                // : "/membership/inputUserInfo/000"
              )
            : openLayerFn($(".alert-layer"));
        }}>
        동의
      </BtnNext>
    </div>
  );

  return (
    <Fragment>
      <ContainerNew
        Title={"약관"}
        dark={"dark"}
        leftMenu={SubMenu}
        bottom={bottom}
        rightMenu={-1}
        isMain={true}
        signUpChannel={props.match.params.signUpChannel}
        goToUrl={"/membership/userPhoneCheck"}>
        <Contents>
          <SubTitle>서비스 약관 동의</SubTitle>
          <div style={{ paddingLeft: "10px", paddingTop: "8px" }}>
            <div
              style={{
                fontSize: "16px",
                letterSpacing: "0.53px",
                textAlign: "left",
                opacity: "1",
              }}>
              케어포미 서비스 약관에 동의해주십시요
            </div>

            <TermsCheckArea setCheckYn={setCheckYn} />

            <LineDiv />

            <div
              style={{
                fontSize: "16px",
                letterSpacing: "0.53px",
                textAlign: "left",
                opacity: "1",
              }}>
              케어포미 앱 이용 권한에 동의해주십시요
            </div>

            <NativeCheckArea />

            <div style={{ paddingTop: "12px", fontSize: "16px" }}>
              {"휴대폰 > 메뉴 > 설정에서 변경이 가능합니다."}
            </div>
          </div>
        </Contents>
      </ContainerNew>
      <TermsViewer />
      <AlertLayer title={""} msg={"약관에 동의해주시기 바랍니다."} />
    </Fragment>
  );
};

const TermsCheckArea = (props) => {
  const { setCheckYn } = props;
  const data = [
    { id: 0, text: "서비스 이용약관", essential: true, termsType: "service" },
    { id: 1, text: "개인정보 수집, 이용약관", essential: true, termsType: "private" },
    { id: 2, text: "위치기반 서비스 이용약관", essential: true, termsType: "location" },
  ];

  // 체크된 아이템을 담을 배열
  const [checkItems, setCheckItems] = useState([]);

  // 체크박스 단일 선택
  const handleSingleCheck = (checked, id) => {
    if (checked) {
      // 단일 선택 시 체크된 아이템을 배열에 추가
      setCheckItems((prev) => [...prev, id]);
    } else {
      // 단일 선택 해제 시 체크된 아이템을 제외한 배열 (필터)
      setCheckItems(checkItems.filter((el) => el !== id));
    }
  };

  // 체크박스 전체 선택
  const handleAllCheck = (checked) => {
    if (checked) {
      // 전체 선택 클릭 시 데이터의 모든 아이템(id)를 담은 배열로 checkItems 상태 업데이트
      const idArray = [];
      data.forEach((el) => idArray.push(el.id));
      setCheckItems(idArray);
    } else {
      // 전체 선택 해제 시 checkItems 를 빈 배열로 상태 업데이트
      setCheckItems([]);
    }
  };

  useEffect(() => {
    if (checkItems.length === data.length) {
      setCheckYn("Y");
    } else {
      setCheckYn("N");
    }
  }, [checkItems]);

  return (
    <div style={{ paddingTop: "4px" }}>
      <TermsCheckContents
        essential={true}
        text="케어포미 서비스 이용약관에 모두 동의합니다."
        checkAll={true}
        handleEvent={handleAllCheck}
        checkItems={checkItems}
        id="all"
        data={data}
      />
      <div style={{ paddingTop: "4px" }}>
        {data.map((data, key) => (
          <TermsCheckContents
            essential={data.essential}
            text={data.text}
            handleEvent={handleSingleCheck}
            checkItems={checkItems}
            id={data.id}
            data={data}
            key={key}
          />
        ))}
      </div>
    </div>
  );
};

const NativeCheckArea = (props) => {
  return (
    <div style={{ paddingTop: "4px" }}>
      <div style={{ paddingTop: "4px" }}>
        <NativeCheckContents
          essential="위치"
          text="현재의 위치를 기준으로 의료기간 위치정보 표시"
        />
        <NativeCheckContents essential="필수" text="사진촬영을 통한 등록가능" />
        <NativeCheckContents
          essential="필수"
          text="저장된 개인자료의 사진 자동저장 및 등록가능"
        />
        <NativeCheckContents
          essential="필수"
          text="서비스 이용을 위한 사진 및 파일 저장기능"
        />
      </div>
    </div>
  );
};

const TermsCheckContents = (props) => {
  // 필수값 essential true/false
  // texx
  const {
    essential,
    text,
    detail,
    checkAll,
    handleEvent,
    checkItems,
    id,
    data,
  } = props;

  return (
    <div style={{ display: "flex", paddingLeft: checkAll ? "0px" : "11px" }}>
      <label className="check-box" style={{display:'flex'}}>
        <div>
          <input
            type="checkbox"
            name={`select-${id}`}
            onChange={(e) => handleEvent(e.target.checked, id)}
            checked={
              checkAll
                ? checkItems.length === data.length
                  ? true
                  : false
                : checkItems.includes(data.id)
                ? true
                : false
            }
          />
          <i />
        </div>

        <div style={{ color: "#00000099" }}>
          {!checkAll && (essential ? "[필수]" : "[선택]")}
          {text}
        </div>
      </label>

      {!checkAll && (
        <div
          style={{ marginLeft: "auto", textDecoration: "underline" }}
          onClick={
            () => 
              {
              data.termsType === "service" && openLayerFn($("#serviceViewer"))
              data.termsType === "location" && openLayerFn($("#locationViewer"))
              data.termsType === "private" && openLayerFn($("#privateViewer"))
              }
          }
        >
          보기
        </div>
      )}
    </div>
  );
};

const NativeCheckContents = (props) => {
  // 필수값 essential true/false
  // texx
  const { essential, text, detail, checkAll } = props;
  return (
    <div style={{ display: "flex", paddingLeft: checkAll ? "0px" : "11px" }}>
      <div style={{ color: "#00000099" }}>
        [{essential}] {text}
      </div>
    </div>
  );
};

const SubTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  margin-top: 37px;
`;

const BtnNext = styled.div`
  bottom: 86px;
  width: ${(props) => window.innerWidth - 30}px;
  height: 50px;
  line-height: 50px;
  background: #000000 0% 0% no-repeat padding-box;
  color: #fff;
  border-radius: 4px;
  opacity: 1;
  font-size: 17px;
`;

const LineDiv = styled.div`
  border: 1px solid #d0d0d0;
  margin: 40px 0px;
`;

const Contents = ({ children }) => {
  return (
    <div className="contents">
      <div className="sub-contents">{children}</div>
    </div>
  );
};
